import React from "react";
import ProgressIndicator from "@/pages/dashboard/components/ProgressIndicator";
import { CheckCircle2 } from "lucide-react";
import { TUser } from "@/types/types";
import { profileSteps, useProfileCompletion } from "@/hooks/useProfileCompletion";

const ProfileCompletionStatus = ({ data }: { data: TUser }) => {
  const { totalProfileCompletion, stepCompletions, isProfileComplete } =
    useProfileCompletion(data);

  return (
    <div className="bg-white p-5 border border-[#E4E7EC] rounded-xl shadow space-y-5">
      {/* Badge */}
      <div
        className={`py-[2px] px-2 rounded-lg ${
          isProfileComplete
            ? "bg-[#E7F5E9] border border-green-200"
            : "bg-[#FDECFC] border border-[#E7E7E7]"
        } inline-flex items-center gap-1`}
      >
        <div
          className={`size-1.5 rounded-full ${
            isProfileComplete ? "bg-green-600" : "bg-[#9411A9]"
          }`}
        ></div>
        <p
          className={`font-semibold text-[11px] leading-4 ${
            isProfileComplete ? "text-green-800" : "text-[#5B0271]"
          }`}
        >
          {isProfileComplete ? "COMPLETE" : "INCOMPLETE"}
        </p>
      </div>

      <h6 className="text-sm tracking-[-1%] leading-5 font-medium">
        {isProfileComplete
          ? "Profile Completed"
          : "Complete Profile to Launch Portfolio"}
      </h6>

      <ProgressIndicator
        barWidth="full"
        color="#000000"
        used={totalProfileCompletion}
        total={100}
      />

      <div>
        {profileSteps.map((step, index) => {
          const stepCompletion = stepCompletions[index];
          return (
            <div
              key={step.id}
              className="flex items-center gap-2 py-3 border-b border-[#E5E7EB] last:border-b-0"
            >
              {stepCompletion.percentage === 100 ? (
                <CheckCircle2 className="size-5 text-green-600" />
              ) : (
                <div className="size-5 rounded-full border border-[#D9D9D9]" />
              )}
              <div className="flex-1">
                <p className="text-xs font-medium leading-[18px]">
                  {step.label}
                </p>
                <p className="text-xs text-gray-500">
                  {stepCompletion.completedCount}/{stepCompletion.totalCount}{" "}
                  fields completed
                </p>
              </div>
              <span className="text-xs text-gray-600">
                {stepCompletion.percentage}%
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProfileCompletionStatus;
